module.exports = __webpack_public_path__ + "img/brick-cafe-interior.4d1b0390.jpg";